// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Tz9w","title":"Header_title__37a63","left":"Header_left__1iIWi","clinicName":"Header_clinicName__2n1MO"};